export default __webpack_public_path__ + "static/media/blitz_logo2.b7074946.png";